import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";

export default function chefsSpecialtyDialog(props) {
  const { closeNoSave, closeSave, open } = props;
  return (
    <div>
      <Dialog aria-labelledby="Rice Choice" open={open} onClose={closeNoSave}>
        <DialogTitle id="Rice Choice">Rice Choice</DialogTitle>
        <div>
          <List>
            <ListItem button onClick={() => closeSave("White Rice")}>
              <ListItemText primary="White Rice" />
            </ListItem>
            <ListItem button onClick={() => closeSave("Brown Rice")}>
              <ListItemText primary="Brown Rice (+$0.50)" />
            </ListItem>
          </List>
        </div>
      </Dialog>
    </div>
  );
}

chefsSpecialtyDialog.propTypes = {
  closeNoSave: PropTypes.func.isRequired,
  closeSave: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
